import {BIRDING_HABITAT_RULES} from "../../../helpers/habitat-classification";
import type {HabitatFamilyLabel} from "../../../helpers/habitat-classification/constants";
import type {HabitatReviewDraft, HabitatReviewItem} from "./types";
import {HABITAT_REVIEW_DEFAULT_REASON} from "./constants";

const HABITAT_FAMILY_BY_LABEL = new Map<string, HabitatFamilyLabel>(
    BIRDING_HABITAT_RULES.map(rule => [rule.label, rule.family])
);

export function getHabitatReviewItemKey(item: HabitatReviewItem) {
    return `${item.locationId}::${item.feedbackType}::${item.suggestedHabitat}`;
}

export function getSuggestedHabitatFamily(item: HabitatReviewItem): HabitatFamilyLabel {
    const suggestedFamily = HABITAT_FAMILY_BY_LABEL.get(item.suggestedHabitat);
    if (suggestedFamily) return suggestedFamily;

    const predictedFamily = item.predictedFamily as HabitatFamilyLabel;
    return predictedFamily || 'Mixed';
}

export function buildInitialHabitatReviewDraft(item: HabitatReviewItem): HabitatReviewDraft {
    const habitat = item.suggestedHabitat || item.predictedHabitat;
    return {
        overrideHabitat: habitat,
        overrideFamily: getSuggestedHabitatFamily(item),
        overrideDisplayHabitat: habitat,
        overrideBaseHabitat: habitat,
        reason: HABITAT_REVIEW_DEFAULT_REASON
    };
}
